import { render, staticRenderFns } from "./ModuleSlide.vue?vue&type=template&id=75ffade1&"
import script from "./ModuleSlide.vue?vue&type=script&lang=js&"
export * from "./ModuleSlide.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSlide.vue?vue&type=style&index=0&id=75ffade1&lang=scss&"
import style1 from "./ModuleSlide.vue?vue&type=style&index=1&id=75ffade1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75ffade1')) {
      api.createRecord('75ffade1', component.options)
    } else {
      api.reload('75ffade1', component.options)
    }
    module.hot.accept("./ModuleSlide.vue?vue&type=template&id=75ffade1&", function () {
      api.rerender('75ffade1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/ModuleSlide.vue"
export default component.exports